/**
 * FIFA World Cup 2026 — 4 teams remaining in semifinals (updated 13 Jul 2026)
 * @see https://www.fifa.com/en/tournaments/mens/worldcup/canadamexicousa2026/articles/knockout-stage-match-schedule-bracket
 */
window.WorldCup2026Teams = [
  { slug: 'argentina', name: 'Argentina', flag: 'ar' },
  { slug: 'england', name: 'England', flag: 'gb-eng' },
  { slug: 'france', name: 'France', flag: 'fr' },
  { slug: 'spain', name: 'Spain', flag: 'es' }
];
